import RestClient from '../../../lib/RestClient';

const URL = '/tour-data/';
//const URL_Avalanche = '/tour-data-avalanche/';
const URL_LIVE = '/tour-data-live'

class TourDataService {
    public getAllTourData(sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string) {
        return RestClient.get(URL, {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter});
    }

    public getAllTourDataAvalanche(sortColumn: String, sortOrder: String, pageToLoad: number, count: number, filter:string, date:string, debtor:string) {

        let dateString = ""

        if (date != null) {

            let dateObj = new Date(date);

            const year = dateObj.getFullYear();
            const month = (dateObj.getMonth() + 1 >= 10) ? dateObj.getMonth() + 1 : "0" + (dateObj.getMonth() + 1);
            const day = (dateObj.getDate() >= 10) ? dateObj.getDate() : "0" + (dateObj.getDate());
            dateString = year + "-" + month + "-" + day;

        }

        return RestClient.get(URL_LIVE, {sortBy: sortColumn, sortDirection: sortOrder, page: pageToLoad, count: count, filter: filter, date:dateString, debtor:debtor});
    }
}

const TourDataServiceSingleton = new TourDataService();

export default TourDataServiceSingleton as TourDataService;
